/**
 * Parse nomenclature quantities from a JSON string and return the total sum
 * @param jsonString
 * @returns number
 */
export const ParseNomenclatureQuantity = (jsonString: string): number => {
    try {
        // Parse la chaîne JSON en objet
        const data = JSON.parse(jsonString);

        // Initialisation de la somme
        let totalQuantity = 0;

        // Itération sur les clés de l'objet (ex: 82384A, 82384B)
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                const item = data[key];

                // Extraction de la quantité et ajout au total
                const qty = parseFloat(item.quantity);

                if (!isNaN(qty)) {
                    totalQuantity += qty;
                }
            }
        }

        // Retourne la somme calculée (ex: 0.0 + 19.0 = 19)
        return totalQuantity;
    } catch (error) {
        // En cas d'erreur (JSON invalide, etc.), on log et on retourne 0
        console.error(`Error processing nomenclature quantity: ${(error as Error).message}`);

        // Comme on attend un nombre pour une somme, on retourne 0 au lieu de la string
        return 0;
    }
};
